<template>
  <div
    class="jTimeLine-group"
    style="margin-left: 30px; width: 500px;">
    <div
      class="bdc-approved first last noSub node child table">
      <div
        class="first last groupBox item">
        <div
          class="last groupData m-t-5">
          <div
            v-for="(i,index) in data_flow.data_position"
            :key="index"
            class="noSub approved node child table">
            <div
              :class="[index === 0 ? 'first' : '']"
              class="item ">
              <div
                :class="[index === 0 ? 'first' : '']"
                class="approved lineBottom"/>

              <div class="td">
                <b-img
                  v-if="i.photo"
                  :src="i.photo"
                  rounded="circle"
                  alt="img"
                  class="m-1 round-bordered-img
                  img-circle staff-img image-popup-link b-page-theme td"/>
                <b-img
                  v-if="!i.photo"
                  :src="require('../../assets/logo/user1.png')"
                  rounded="circle"
                  alt="img"
                  class="m-1 round-bordered-img
                  img-circle staff-img image-popup-link b-page-theme td"/>
              </div>
              <div
                class="td p-l-5 p-t-15"
                style="width: 375px;">
                <div style="display:grid; padding-top: 5px;">
                  <div class="no-margin c-grey ellipsis">{{ i.first_name }}
                    {{ i.last_name }}</div>
                  <div class="no-margin c-page-theme ellipsis">{{ i.position }}</div>
                </div>
              </div>
              <div
                class="td"
                style="padding-top: 10px"
                @click="deletePositionByDivision(index)">
                <i class="fa fa-trash fa-2x"/>
              </div>

            </div>
          </div>
          <div style="margin-top: 5px">
            <b-row>
              <b-col
                md="7">
                <j-single-select
                  v-model="$v.data_flow.position.$model"
                  :is-async="true"
                  :load-options="loadOptionsPosition"
                  :default-options="false"
                  placeholder="Position"
                  value-format="object"
                  label="name" />
              </b-col>
              <b-col
                md="3"
                style="padding-left: 0px">
                <b-button
                  class="btn blue outline"
                  @click="addPositionByDivision">
                  <i class="fa fa-plus"/>
                </b-button>
              </b-col>
            </b-row>
          </div>
        </div>
        <!-- end is_group -->
        <hr>
        <!-- linebottom -->
        <div
          class="p-l-5 p-t-5">
          <div class="no-margin c-grey">Flow Type</div>
          <b-row>
            <b-col
              md="7">
              <j-single-select
                v-model="$v.data_flow.type.$model"
                :options="flow_type"
                label="name"
                value-format="object"
                placeholder="Flow Type"/>
            </b-col>
            <!-- <b-col
              md="5"
              style="padding-left: 0px">
              <b-button
                class="btn blue outline"
                @click="saveCreateFlowDivision">
                Done
              </b-button>
              <b-button
                v-if="data_flow.id !== 0"
                class="btn grey outline"
                @click="deletedFlowDivision">
                Delete
              </b-button>
            </b-col> -->
          </b-row>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable vue/name-property-casing, vue/html-closing */
// eslint-disable-next-line
import { ASYNC_SEARCH } from '@riophae/vue-treeselect';
import { required } from 'vuelidate/lib/validators';
import { mapState, mapActions } from 'vuex';

export default {
  validations: {
    data_flow: {
      position: {

      },
      data_position: {
        required,
      },
      type: {
        required,
      },
    },
  },
  name: 'jDivisionFlow',
  props: {
    flow: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      data_flow: {
        id: 0,
        position: null,
        data_position: [],
        type: null,
      },
      data_position_deleted: [],
      flow_type: [
        {
          id: 1,
          type: 1,
          name: 'Order',
          minimum_action: 0,
        },
        {
          id: 2,
          type: 2,
          name: 'No Order',
          minimum_action: 0,
        },
        {
          id: 3,
          type: 3,
          name: 'Minimum 1',
          minimum_action: 1,
        },
        {
          id: 4,
          type: 3,
          name: 'Minimum 2',
          minimum_action: 2,
        },
        {
          id: 5,
          type: 3,
          name: 'Minimum 3',
          minimum_action: 3,
        },
      ],
    };
  },
  computed: {
    ...mapState('jStoreFlows', ['detail_flow']),

    generateData() {
      const dataPosition = [];
      this.data_flow.data_position.forEach((lab, index) => {
        const data = {
          id: lab.id,
          organigram_id: lab.organigram_id,
          order: index + 1,
          is_delete: false,
        };
        dataPosition.push(data);
      });
      const genData = {
        division_id: this.$route.params.id,
        flow: {
          id: this.data_flow.id,
          type: this.data_flow.type.type,
          minimum_action: this.data_flow.type.minimum_action,
          members: dataPosition,
        },
      };
      return genData;
    },

    generateDataUpdate() {
      const dataPosition = [];
      this.data_flow.data_position.forEach((lab, index) => {
        const data = {
          id: lab.id,
          organigram_id: lab.organigram_id,
          order: index + 1,
          is_delete: false,
        };
        dataPosition.push(data);
      });
      this.data_position_deleted.forEach((lab) => {
        const data = {
          id: lab.id,
          organigram_id: lab.organigram_id,
          order: 0,
          is_delete: true,
        };
        dataPosition.push(data);
      });
      const genData = {
        division_id: this.$route.params.id,
        flow: {
          id: this.data_flow.id,
          type: this.data_flow.type.type,
          minimum_action: this.data_flow.type.minimum_action,
          members: dataPosition,
        },
      };
      return genData;
    },
  },
  watch: {
    flow(newVal) {
      this.data_flow.id = newVal;
      this.modeUpdateFlow(newVal);
    },

    detail_flow(newVal) {
      const dataPosition = [];
      newVal.members.forEach((lab) => {
        const firstName = typeof lab.user !== 'undefined' ? lab.user[0].profile.first_name : '-';
        const lastName = typeof lab.user !== 'undefined' ? lab.user[0].profile.last_name : '';
        const photoUrl = typeof lab.user !== 'undefined' ? lab.user[0].profile.photo_url : '';

        const data = {
          id: lab.id,
          photo: photoUrl,
          first_name: firstName,
          last_name: lastName,
          position: lab.org_name,
          organigram_id: lab.organigram_id,
        };
        dataPosition.push(data);
      });

      const dataType = this.flow_type.filter(fildat =>
        fildat.name.toLowerCase() === newVal.type_name.toLowerCase());

      const flowForm = {
        id: newVal.id,
        data_position: dataPosition,
        type: dataType[0],
      };
      this.data_flow = flowForm;
    },
  },
  methods: {
    ...mapActions('jStoreDivisionFlow', ['createFlowDivision', 'updateFlowDivision', 'deleteFlowDivision', 'setDataFlowDivision']),
    ...mapActions('jStoreFlows', ['getDetailFlow']),

    modeUpdateFlow(ids) {
      const flowId = {
        id: ids,
      };
      this.getDetailFlow(flowId);
    },

    validateStatus(val) {
      return val === '' ? 'default' : val;
    },

    loadOptionsPositionByDivision({ action, searchQuery, callback }) {
      if (action === ASYNC_SEARCH) {
        const reqData = {
          division_id: this.$route.params.id,
          pagination: {
            limit: 50,
            page: 1,
            column: '',
            ascending: true,
            query: searchQuery,
            query_type: 'position',
          },
        };
        this.$store.dispatch('jStoreFlows/getListByDivisions', { reqData, callback });
      }
    },

    loadOptionsPosition({ action, searchQuery, callback }) {
      if (action === ASYNC_SEARCH) {
        const reqData = {
          pagination: {
            limit: 50,
            page: 1,
            column: '',
            ascending: true,
            query: searchQuery,
            query_type: 'position',
          },
        };
        this.$store.dispatch('jStoreFlows/getListPosition', { reqData, callback, label: 'name' });
      }
    },

    addPositionByDivision() {
      if (this.data_flow.position) {
        const firstName = typeof this.data_flow.position.user !== 'undefined' ? this.data_flow.position.user.profile.first_name : '-';
        const lastName = typeof this.data_flow.position.user !== 'undefined' ? this.data_flow.position.user.profile.last_name : '';
        const photoUrl = typeof this.data_flow.position.user !== 'undefined' ? this.data_flow.position.user.profile.photo_url : '';

        const data = {
          id: 0,
          photo: photoUrl,
          first_name: firstName,
          last_name: lastName,
          position: this.data_flow.position.name,
          organigram_id: this.data_flow.position.id,
        };
        this.data_flow.data_position.push(data);
        this.data_flow.position = null;
      }
    },

    deletePositionByDivision(index) {
      if (this.data_flow.data_position[index].id !== 0) {
        const data = {
          id: this.data_flow.data_position[index].id,
          photo: this.data_flow.data_position[index].photo,
          first_name: this.data_flow.data_position[index].first_name,
          last_name: this.data_flow.data_position[index].last_name,
          position: this.data_flow.data_position[index].position,
          organigram_id: this.data_flow.data_position[index].organigram_id,
        };
        this.data_position_deleted.push(data);
      }

      this.data_flow.data_position.splice(index, 1);
    },

    saveCreateFlowDivision() {
      if (this.data_flow !== null) {
        if (this.flow === 0) {
          this.createFlowDivision(this.generateData);
        } else {
          this.updateFlowDivision(this.generateDataUpdate);
        }
      }
    },

    deletedFlowDivision() {
      const text = 'You want to delete this flow';

      this.$swal({
        title: 'Are you sure?',
        text,
        type: 'question',
        showCancelButton: true,
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes',
      }).then((result) => {
        if (result.value) {
          this.deleteFlowDivision({ division_id: this.$route.params.id });
        }
      });
    },

    save() {
      if (this.data_flow.data_position.length > 0 || this.data_flow.type !== null) {
        if (this.flow === 0) {
          this.setDataFlowDivision(this.generateData);
        } else {
          this.setDataFlowDivision(this.generateDataUpdate);
        }
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/division/jDivisionFlow.vue